<section class="flex flex-col font-display">
  <span class="text-2xl font-bold sm:text-3xl">Report Menu</span>
  <mat-tab-group
    mat-stretch-tabs="false"
    class="mt-4"
    (selectedTabChange)="tabIndex = $event.index"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="font-display">All</span>
      </ng-template>
      <app-all *ngIf="tabIndex === 0"></app-all>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="font-display">Reimbursement</span>
      </ng-template>
      <app-reimbursement *ngIf="tabIndex === 1"></app-reimbursement>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="font-display">Cash Advance</span>
      </ng-template>
      <app-cash-advance *ngIf="tabIndex === 2"></app-cash-advance>
    </mat-tab>
  </mat-tab-group>
</section>
